import { type Component, createMemo, createResource, createSignal, For, Show } from 'solid-js';
import {
  connectIntegration,
  disconnectIntegration,
  fetchIntegrations,
  fetchMyIntegrations,
  type Integration,
} from '../services/api';

// Integration icons by service
const serviceIcons: Record<string, string> = {
  gmail:
    'M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64 12 9.548l6.545-4.91 1.528-1.145C21.69 2.28 24 3.434 24 5.457z',
  slack:
    'M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zm1.271 0a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zm0 1.271a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zm10.122 2.521a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zm-1.268 0a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zm-2.523 10.122a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zm0-1.268a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z',
  github:
    'M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12',
  openai:
    'M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.896zm16.597 3.855l-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023l-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135l-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08-4.778 2.758a.795.795 0 0 0-.393.681zm1.097-2.365l2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z',
  notion:
    'M4.459 4.208c.746.606 1.026.56 2.428.466l13.215-.793c.28 0 .047-.28-.046-.326L17.86 1.968c-.42-.326-.981-.7-2.055-.607L3.01 2.295c-.466.046-.56.28-.374.466zm.793 3.08v13.904c0 .747.373 1.027 1.214.98l14.523-.84c.84-.046.933-.56.933-1.167V6.354c0-.606-.233-.933-.746-.886l-15.177.887c-.56.046-.747.326-.747.933zm14.337.745c.093.42 0 .84-.42.888l-.7.14v10.264c-.608.327-1.168.514-1.635.514-.748 0-.935-.234-1.495-.933l-4.577-7.186v6.952L12.21 19s0 .84-1.168.84l-3.222.186c-.093-.186 0-.653.327-.746l.84-.233V9.854L7.822 9.76c-.094-.42.14-1.026.793-1.073l3.456-.233 4.764 7.279v-6.44l-1.215-.139c-.093-.514.28-.887.747-.933zM1.936 1.035l13.31-.98c1.634-.14 2.055-.047 3.082.7l4.249 2.986c.7.513.933.653.933 1.213v16.378c0 1.026-.373 1.634-1.68 1.726l-15.458.934c-.98.047-1.448-.093-1.962-.747l-3.129-4.06c-.56-.747-.793-1.306-.793-1.96V2.667c0-.839.374-1.54 1.448-1.632z',
  anthropic: 'M17.304 3h4.022l-8.044 18h-4.021l8.043-18Zm-8.587 0H4.696L12.739 21h4.021L8.717 3Z',
};

// Category colors
const categoryColors: Record<string, string> = {
  ai: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  communication: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  productivity: 'bg-green-500/20 text-green-400 border-green-500/30',
  development: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  storage: 'bg-cyan-500/20 text-cyan-400 border-cyan-500/30',
  analytics: 'bg-pink-500/20 text-pink-400 border-pink-500/30',
};

const Integrations: Component = () => {
  const [activeTab, setActiveTab] = createSignal<'available' | 'connected'>('available');
  const [categoryFilter, setCategoryFilter] = createSignal<string | null>(null);
  const [searchQuery, setSearchQuery] = createSignal('');
  const [connectingId, setConnectingId] = createSignal<string | null>(null);
  const [disconnectingId, setDisconnectingId] = createSignal<string | null>(null);
  const [showConnectModal, setShowConnectModal] = createSignal(false);
  const [selectedIntegration, setSelectedIntegration] = createSignal<Integration | null>(null);
  const [apiKey, setApiKey] = createSignal('');

  // Fetch available integrations
  const [integrations, { refetch: _refetchIntegrations }] = createResource(fetchIntegrations);

  // Fetch connected integrations
  const [myIntegrations, { refetch: refetchMyIntegrations }] = createResource(fetchMyIntegrations);

  // Get unique categories
  const categories = createMemo(() => {
    const cats = new Set<string>();
    integrations()?.forEach((i) => {
      if (i.category) cats.add(i.category);
    });
    return Array.from(cats).sort();
  });

  // Check if an integration is connected
  const isConnected = (integrationId: string) => {
    return myIntegrations()?.some(
      (m) => m.integration_id === integrationId && m.status === 'active',
    );
  };

  // Get connection status
  const getConnectionStatus = (integrationId: string) => {
    const conn = myIntegrations()?.find((m) => m.integration_id === integrationId);
    return conn?.status;
  };

  // Filtered integrations
  const filteredIntegrations = createMemo(() => {
    let items = integrations() || [];

    // Filter by category
    if (categoryFilter()) {
      items = items.filter((i) => i.category === categoryFilter());
    }

    // Filter by search
    if (searchQuery().trim()) {
      const query = searchQuery().toLowerCase();
      items = items.filter(
        (i) =>
          i.name.toLowerCase().includes(query) ||
          i.service.toLowerCase().includes(query) ||
          i.description?.toLowerCase().includes(query),
      );
    }

    return items;
  });

  // Handle connect
  const handleConnect = async () => {
    const integration = selectedIntegration();
    if (!integration) return;

    setConnectingId(integration.id);
    try {
      await connectIntegration(integration.id, { api_key: apiKey() });
      refetchMyIntegrations();
      setShowConnectModal(false);
      setSelectedIntegration(null);
      setApiKey('');
    } catch (err) {
      console.error('Failed to connect:', err);
    } finally {
      setConnectingId(null);
    }
  };

  // Handle disconnect
  const handleDisconnect = async (integrationId: string) => {
    setDisconnectingId(integrationId);
    try {
      await disconnectIntegration(integrationId);
      refetchMyIntegrations();
    } catch (err) {
      console.error('Failed to disconnect:', err);
    } finally {
      setDisconnectingId(null);
    }
  };

  // Open connect modal
  const openConnectModal = (integration: Integration) => {
    setSelectedIntegration(integration);
    setApiKey('');
    setShowConnectModal(true);
  };

  return (
    <div>
      {/* Header */}
      <div class="flex items-center justify-between mb-6">
        <div>
          <h1 class="text-2xl font-semibold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
            Integrations
          </h1>
          <p class="text-gray-400 text-sm mt-1">
            Connect external services to power your agents and skills
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div class="flex items-center gap-1 mb-6 bg-gray-800/50 rounded-lg p-1 w-fit">
        <button
          type="button"
          onClick={() => setActiveTab('available')}
          class={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            activeTab() === 'available'
              ? 'bg-gray-700 text-white'
              : 'text-gray-400 hover:text-gray-200'
          }`}
        >
          Available
          <Show when={integrations()}>
            <span class="ml-2 text-xs text-gray-500">({integrations()?.length})</span>
          </Show>
        </button>
        <button
          type="button"
          onClick={() => setActiveTab('connected')}
          class={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            activeTab() === 'connected'
              ? 'bg-gray-700 text-white'
              : 'text-gray-400 hover:text-gray-200'
          }`}
        >
          Connected
          <Show when={myIntegrations()}>
            <span class="ml-2 text-xs text-gray-500">
              ({myIntegrations()?.filter((m) => m.status === 'active').length})
            </span>
          </Show>
        </button>
      </div>

      {/* Filters (only for available tab) */}
      <Show when={activeTab() === 'available'}>
        <div class="flex flex-wrap items-center gap-4 mb-6">
          {/* Search */}
          <div class="relative flex-1 max-w-md">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"
            >
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.3-4.3" />
            </svg>
            <input
              type="text"
              placeholder="Search integrations..."
              value={searchQuery()}
              onInput={(e) => setSearchQuery(e.currentTarget.value)}
              class="w-full pl-10 pr-4 py-2 rounded-lg bg-gray-800/50 border border-gray-700 text-gray-200 placeholder-gray-500 focus:outline-none focus:border-cyan-500 transition-colors text-sm"
            />
          </div>

          {/* Category filter */}
          <div class="flex items-center gap-2 flex-wrap">
            <button
              type="button"
              onClick={() => setCategoryFilter(null)}
              class={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                categoryFilter() === null
                  ? 'bg-cyan-500/20 text-cyan-400 border border-cyan-500/30'
                  : 'bg-gray-800 text-gray-400 hover:text-gray-200 border border-gray-700'
              }`}
            >
              All
            </button>
            <For each={categories()}>
              {(category) => (
                <button
                  type="button"
                  onClick={() => setCategoryFilter(category)}
                  class={`px-3 py-1.5 rounded-lg text-xs font-medium capitalize transition-colors ${
                    categoryFilter() === category
                      ? categoryColors[category] ||
                        'bg-gray-500/20 text-gray-400 border-gray-500/30'
                      : 'bg-gray-800 text-gray-400 hover:text-gray-200 border border-gray-700'
                  } border`}
                >
                  {category}
                </button>
              )}
            </For>
          </div>
        </div>
      </Show>

      {/* Loading state */}
      <Show when={integrations.loading || myIntegrations.loading}>
        <div class="flex items-center justify-center py-12">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-500" />
        </div>
      </Show>

      {/* Available Integrations Grid */}
      <Show when={activeTab() === 'available' && !integrations.loading}>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <For each={filteredIntegrations()}>
            {(integration) => {
              const connected = isConnected(integration.id);
              const _status = getConnectionStatus(integration.id);

              return (
                <div
                  class={`relative bg-gray-800/50 rounded-xl border p-5 transition-all hover:border-gray-600 ${
                    connected ? 'border-green-500/50' : 'border-gray-700'
                  }`}
                >
                  {/* Connected badge */}
                  <Show when={connected}>
                    <div class="absolute top-3 right-3">
                      <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-green-500/20 text-green-400 text-xs">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="10"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M20 6 9 17l-5-5" />
                        </svg>
                        Connected
                      </span>
                    </div>
                  </Show>

                  {/* Icon & Name */}
                  <div class="flex items-start gap-4 mb-4">
                    <div class="w-12 h-12 rounded-xl bg-gray-700 flex items-center justify-center flex-shrink-0">
                      <Show
                        when={serviceIcons[integration.service]}
                        fallback={
                          <span class="text-lg font-bold text-gray-400">
                            {integration.name.charAt(0)}
                          </span>
                        }
                      >
                        <svg viewBox="0 0 24 24" class="w-6 h-6 text-gray-300" fill="currentColor">
                          <path d={serviceIcons[integration.service]} />
                        </svg>
                      </Show>
                    </div>
                    <div class="flex-1 min-w-0">
                      <h3 class="font-medium text-gray-200 truncate">
                        {integration.service_display_name || integration.name}
                      </h3>
                      <Show when={integration.category}>
                        <span
                          class={`inline-block px-2 py-0.5 rounded text-xs capitalize mt-1 ${
                            categoryColors[integration.category!] || 'bg-gray-500/20 text-gray-400'
                          }`}
                        >
                          {integration.category}
                        </span>
                      </Show>
                    </div>
                  </div>

                  {/* Description */}
                  <p class="text-gray-400 text-sm mb-4 line-clamp-2">
                    {integration.description || `Connect your ${integration.name} account`}
                  </p>

                  {/* Capabilities */}
                  <Show when={integration.capabilities && integration.capabilities.length > 0}>
                    <div class="flex flex-wrap gap-1 mb-4">
                      <For each={integration.capabilities?.slice(0, 3)}>
                        {(cap) => (
                          <span class="px-2 py-0.5 bg-gray-700/50 text-gray-400 rounded text-xs">
                            {cap}
                          </span>
                        )}
                      </For>
                      <Show when={(integration.capabilities?.length || 0) > 3}>
                        <span class="px-2 py-0.5 text-gray-500 text-xs">
                          +{(integration.capabilities?.length || 0) - 3} more
                        </span>
                      </Show>
                    </div>
                  </Show>

                  {/* Action button */}
                  <Show
                    when={!connected}
                    fallback={
                      <button
                        type="button"
                        onClick={() => handleDisconnect(integration.id)}
                        disabled={disconnectingId() === integration.id}
                        class="w-full py-2 rounded-lg bg-gray-700 hover:bg-red-500/20 hover:text-red-400 text-gray-300 text-sm font-medium transition-colors disabled:opacity-50"
                      >
                        {disconnectingId() === integration.id ? 'Disconnecting...' : 'Disconnect'}
                      </button>
                    }
                  >
                    <button
                      type="button"
                      onClick={() => openConnectModal(integration)}
                      class="w-full py-2 rounded-lg bg-cyan-600 hover:bg-cyan-500 text-white text-sm font-medium transition-colors"
                    >
                      Connect
                    </button>
                  </Show>
                </div>
              );
            }}
          </For>
        </div>

        {/* Empty state */}
        <Show when={filteredIntegrations().length === 0}>
          <div class="text-center py-12">
            <div class="w-16 h-16 rounded-full bg-gray-800 flex items-center justify-center mx-auto mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="text-gray-500"
              >
                <path d="M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" />
                <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                <circle cx="4" cy="14" r="2" />
                <path d="m20 14-4.5 4.5" />
                <path d="m14 10 4.5 4.5" />
                <path d="m4 16 4 4" />
              </svg>
            </div>
            <h3 class="text-lg font-medium text-gray-300 mb-2">No integrations found</h3>
            <p class="text-gray-500 text-sm">Try adjusting your search or filter criteria.</p>
          </div>
        </Show>
      </Show>

      {/* Connected Integrations */}
      <Show when={activeTab() === 'connected' && !myIntegrations.loading}>
        <div class="space-y-4">
          <For each={myIntegrations()?.filter((m) => m.status === 'active')}>
            {(conn) => {
              const integration = conn.integrations;
              if (!integration) return null;

              return (
                <div class="bg-gray-800/50 rounded-xl border border-gray-700 p-5 flex items-center justify-between">
                  <div class="flex items-center gap-4">
                    <div class="w-12 h-12 rounded-xl bg-gray-700 flex items-center justify-center flex-shrink-0">
                      <Show
                        when={serviceIcons[integration.service]}
                        fallback={
                          <span class="text-lg font-bold text-gray-400">
                            {integration.name.charAt(0)}
                          </span>
                        }
                      >
                        <svg viewBox="0 0 24 24" class="w-6 h-6 text-gray-300" fill="currentColor">
                          <path d={serviceIcons[integration.service]} />
                        </svg>
                      </Show>
                    </div>
                    <div>
                      <h3 class="font-medium text-gray-200">
                        {integration.service_display_name || integration.name}
                      </h3>
                      <p class="text-sm text-gray-500">
                        Connected {new Date(conn.created_at).toLocaleDateString()}
                        {conn.last_used && (
                          <span class="ml-2">
                            · Last used {new Date(conn.last_used).toLocaleDateString()}
                          </span>
                        )}
                      </p>
                    </div>
                  </div>

                  <div class="flex items-center gap-3">
                    <span class="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-green-500/20 text-green-400 text-xs">
                      <span class="w-1.5 h-1.5 rounded-full bg-green-400" />
                      Active
                    </span>
                    <button
                      type="button"
                      onClick={() => handleDisconnect(conn.integration_id)}
                      disabled={disconnectingId() === conn.integration_id}
                      class="px-4 py-2 rounded-lg bg-gray-700 hover:bg-red-500/20 hover:text-red-400 text-gray-300 text-sm font-medium transition-colors disabled:opacity-50"
                    >
                      {disconnectingId() === conn.integration_id
                        ? 'Disconnecting...'
                        : 'Disconnect'}
                    </button>
                  </div>
                </div>
              );
            }}
          </For>
        </div>

        {/* Empty state for connected */}
        <Show when={myIntegrations()?.filter((m) => m.status === 'active').length === 0}>
          <div class="text-center py-12">
            <div class="w-16 h-16 rounded-full bg-gray-800 flex items-center justify-center mx-auto mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="text-gray-500"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="m4.9 4.9 14.2 14.2" />
              </svg>
            </div>
            <h3 class="text-lg font-medium text-gray-300 mb-2">No connected integrations</h3>
            <p class="text-gray-500 text-sm mb-4">
              Connect external services to enhance your agents and skills.
            </p>
            <button
              type="button"
              onClick={() => setActiveTab('available')}
              class="px-4 py-2 rounded-lg bg-cyan-600 hover:bg-cyan-500 text-white text-sm font-medium transition-colors"
            >
              Browse Available Integrations
            </button>
          </div>
        </Show>
      </Show>

      {/* Connect Modal */}
      <Show when={showConnectModal() && selectedIntegration()}>
        <div class="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
          <div class="bg-gray-900 rounded-xl border border-gray-700 w-full max-w-md">
            <div class="p-6 border-b border-gray-700">
              <div class="flex items-center gap-4">
                <div class="w-12 h-12 rounded-xl bg-gray-800 flex items-center justify-center">
                  <Show
                    when={serviceIcons[selectedIntegration()!.service]}
                    fallback={
                      <span class="text-lg font-bold text-gray-400">
                        {selectedIntegration()!.name.charAt(0)}
                      </span>
                    }
                  >
                    <svg viewBox="0 0 24 24" class="w-6 h-6 text-gray-300" fill="currentColor">
                      <path d={serviceIcons[selectedIntegration()!.service]} />
                    </svg>
                  </Show>
                </div>
                <div>
                  <h2 class="text-lg font-medium text-gray-200">
                    Connect{' '}
                    {selectedIntegration()!.service_display_name || selectedIntegration()!.name}
                  </h2>
                  <p class="text-sm text-gray-500">Enter your credentials to connect</p>
                </div>
              </div>
            </div>

            <div class="p-6">
              <Show when={selectedIntegration()?.auth_type === 'api_key'}>
                <div>
                  <label class="block text-sm font-medium text-gray-300 mb-2">API Key</label>
                  <input
                    type="password"
                    value={apiKey()}
                    onInput={(e) => setApiKey(e.currentTarget.value)}
                    placeholder="Enter your API key"
                    class="w-full px-4 py-3 rounded-lg bg-gray-800 border border-gray-600 text-gray-200 placeholder-gray-500 focus:outline-none focus:border-cyan-500 transition-colors"
                  />
                  <p class="text-xs text-gray-500 mt-2">
                    Your API key is encrypted and stored securely.
                  </p>
                </div>
              </Show>

              <Show when={selectedIntegration()?.auth_type === 'oauth2'}>
                <p class="text-gray-400 text-sm">
                  You will be redirected to {selectedIntegration()!.name} to authorize access.
                </p>
              </Show>

              <Show
                when={
                  !selectedIntegration()?.auth_type || selectedIntegration()?.auth_type === 'none'
                }
              >
                <p class="text-gray-400 text-sm">
                  This integration does not require authentication.
                </p>
              </Show>
            </div>

            <div class="p-6 border-t border-gray-700 flex justify-end gap-3">
              <button
                type="button"
                onClick={() => {
                  setShowConnectModal(false);
                  setSelectedIntegration(null);
                  setApiKey('');
                }}
                class="px-4 py-2 rounded-lg bg-gray-700 hover:bg-gray-600 text-gray-300 text-sm font-medium transition-colors"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleConnect}
                disabled={
                  connectingId() !== null ||
                  (selectedIntegration()?.auth_type === 'api_key' && !apiKey().trim())
                }
                class="px-4 py-2 rounded-lg bg-cyan-600 hover:bg-cyan-500 text-white text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {connectingId() !== null ? 'Connecting...' : 'Connect'}
              </button>
            </div>
          </div>
        </div>
      </Show>
    </div>
  );
};

export default Integrations;
